/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2024, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

import TelemetryTableView from './TelemetryTableView.js';

export default function TelemetryTableViewProvider(openmct, options) {
  function hasTelemetry(domainObject) {
    if (!Object.prototype.hasOwnProperty.call(domainObject, 'telemetry')) {
      return false;
    }

    let metadata = openmct.telemetry.getMetadata(domainObject);

    return metadata.values().length > 0;
  }

  return {
    key: 'table',
    name: 'Telemetry Table',
    cssClass: 'icon-tabular-scrolling',
    canView(domainObject) {
      return domainObject.type === 'table' || hasTelemetry(domainObject);
    },
    canEdit(domainObject) {
      return domainObject.type === 'table';
    },
    view(domainObject, objectPath) {
      return new TelemetryTableView(openmct, domainObject, objectPath, options);
    },
    priority() {
      return openmct.priority.LOW;
    }
  };
}
